import { render, staticRenderFns } from "./admin-orders.vue?vue&type=template&id=53570cc5"
import script from "./admin-orders.vue?vue&type=script&lang=js"
export * from "./admin-orders.vue?vue&type=script&lang=js"
import style0 from "./admin-orders.vue?vue&type=style&index=0&id=53570cc5&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports